<div class="min-h-screen px-8 py-8 ltr:text-left rtl:text-right">
  <h1 class="text-primary mb-8 text-[28px] font-[700]" i18n="@@deactivateAccountTitle">Deactivate Account</h1>
  <div class="w-full rounded-[12px] bg-white p-8 shadow-[0px_0px_12px_1px_rgba(0,0,0,0.06)]">
    <div class="mb-4 flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-50">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M10 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m7.5 9C15 13 13 15 13 17.5s2 4.5 4.5 4.5s4.5-2 4.5-4.5s-2-4.5-4.5-4.5M10 14c-4.42 0-8 1.79-8 4v2h9.5a6.5 6.5 0 0 1-.5-2.5a6.5 6.5 0 0 1 .95-3.36c-.63-.08-1.27-.14-1.95-.14m7.5.5c1.66 0 3 1.34 3 3c0 .56-.15 1.08-.42 1.5L16 14.92c.42-.27.94-.42 1.5-.42M14.92 16L19 20.08c-.42.27-.94.42-1.5.42c-1.66 0-3-1.34-3-3c0-.56.15-1.08.42-1.5" />
        </svg>
      </div>
      <h1 class="text-text-heading text-[20px] font-[700]" i18n="@@deactivateAccountTitle">Deactivate Account</h1>
    </div>

    <hr class="mb-8 border-t border-gray-100" />

    <div class="border-warning-accent mb-8 rounded-[12px] border-2 bg-white p-6">
      <div class="text-warning-accent mb-3 flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM11 16h2v2h-2zm0-6h2v4h-2z" />
        </svg>
        <span class="text-[16px] font-[700]" i18n="@@deactivateAccountWarning">Warning!</span>
      </div>
      <p class="text-[15px] leading-[1.6] text-gray-600" i18n="@@deactivateAccountWarningText">
        Deactivating your account will temporarily disable your access. You can reactivate your account anytime by
        logging in again
      </p>
    </div>

    <div class="mb-10 text-center">
      <h2 class="text-text-body text-[18px] font-[600]" i18n="@@deactivateAccountConfirmQuestion">
        Are you absolutely sure you want to Deactivate your account?
      </h2>
    </div>

    <div class="flex flex-col-reverse justify-end gap-3 md:flex-row">
      <button
        type="button"
        (click)="onCancel()"
        class="border-primary text-primary hover-bg-primary-10 min-w-[120px] cursor-pointer rounded-[8px] border px-6 py-2.5 text-[14px] font-[600] transition-all"
        i18n="@@deactivateAccountCancelButton">
        Cancel
      </button>

      <button
        type="button"
        (click)="onSave()"
        [disabled]="loading()"
        class="bg-primary hover-bg-primary-hover min-w-[150px] cursor-pointer rounded-[8px] px-8 py-2.5 text-[14px] font-[600] text-white transition-all disabled:opacity-50">
        <div class="flex items-center justify-center gap-2">
          @if (loading()) {
            <span class="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white"></span>
          }
          <span i18n="@@deactivateAccountSaveButton">
            {{ loading() ? "Deactivating..." : "Save" }}
          </span>
        </div>
      </button>
    </div>
  </div>
</div>
